



































import { Component, Vue } from 'vue-property-decorator';
import { PasswordNew } from '@/models';

@Component({})
export default class PasswordNewPage extends Vue {
  form: PasswordNew = new PasswordNew();
  token = '';
  userKey = '';

  created() {
    this.token = this.$route.params.token;
    this.userKey = this.$route.params.userKey;
  }

  submit(): void {
    (this.$refs.form as any).validate();
    if (this.form.valid) {
      const form = this.form;
      const resetToken = this.token;
      const userKey = this.userKey;

      this.$store.dispatch('account/passwordNew', { form, resetToken, userKey }).then(() => {
        (this.$refs.form as any).reset();
      });
    }
  }
}
